// eslint-disable-next-line consistent-return
export const getTariffNameByOptionKey = (tariffMap: any, option: string): string | undefined => {
  const tariffMapKeys: Array<string> = Object.keys(tariffMap)

  for (const key of tariffMapKeys) {
    if ((tariffMap[key] as Array<string>).includes(option)) {
      return key
    }
  }
}
